<template>
  <div class="text-left">
    <div class="flex-between" style="margin-bottom:64px">
      <div class="size-21" style="color:#363636">솔루션 이용 플랜 수정</div>
      <img :src="svgSrc('fi_close_outline')" class="svg-sub2 unselect" @click="$emit('close')">
    </div>

    <template>
      <!-- 결제 완료 내역 -->
      <template>
        <div class="terminate-modal-title" style="margin-bottom:24px">
          이용 중인 서비스 <span v-if="!isFree">- 결제 완료 내역</span>
          <div class="terminate-modal-content" style="margin-top:8px" v-if="isFree">
            {{ datesFormat(service.service_order.free_date, 'date_3') }}까지 무료 체험
          </div>
          <div class="terminate-modal-content" style="margin-top:8px" v-else>
            지금 해지해도 아래 이용기간까지 구매한 서비스를 계속 이용할 수 있습니다.
          </div>
        </div>

        <table class="table amt-table" style="width:100%">
          <thead>
          <tr>
            <th class="col-1">구매일</th>
            <th class="col-1">결제일</th>
            <th class="col-1">구분</th>
            <th class="col-1">내용</th>
            <th class="col-3"></th>
            <th class="col-1">플랜</th>
            <th class="col-3">서비스 이용기간</th>
            <th class="col-1">금액</th>
          </tr>
          </thead>
          <tbody>
          <!-- 솔루션 -->
          <tr v-if="after_pay.service_order">
            <td>{{ datesFormat(after_pay.service_order.created_time, 'date_3') }}</td>
            <td>{{ payDay(after_pay.service_order) }}</td>
            <td>솔루션</td>
            <td>{{ after_pay.service_order.options[0].name }}</td>
            <td></td>
            <td>{{ after_pay.service_order.date_unit }}개월</td>
            <td>{{ datesFormat(after_pay.service_order.start_date, 'date_3') }}~{{ datesFormat(after_pay.service_order.end_date, 'date_3') }}</td>
            <td>{{ isFree ? 0 : usingSolutionPrice | currency }}</td>
          </tr>
          <!-- 호스팅 -->
          <tr v-if="after_pay.service_order">
            <td>{{ datesFormat(after_pay.service_order.created_time, 'date_3') }}</td>
            <td>{{ payDay(after_pay.service_order) }}</td>
            <td>호스팅</td>
            <td>{{ after_pay.service_order.hosting.name }}</td>
            <td></td>
            <td>{{ after_pay.service_order.date_unit }}개월</td>
            <td>{{ datesFormat(after_pay.service_order.start_date, 'date_3') }}~{{ datesFormat(after_pay.service_order.end_date, 'date_3') }}</td>
            <td>{{ isFree ? 0 : usinghostingPrice | currency }}</td>
          </tr>
          <!-- 앱마켓 -->
          <tr v-for="(order, order_idx) in after_pay.service_app_order" :key="`order-${order_idx}`">
            <td>{{ datesFormat(order.created_time, 'date_3') }}</td>
            <td>{{ payDay(order) }}</td>
            <td>{{ order.product.category1_name }}</td>
            <td>{{ order.product.category2_name }}</td>
            <td>{{ order.product.name }}</td>
            <td>{{ computedPlan(order) }}</td>
            <td>
              <template v-if="order.is_subscription">
                {{ datesFormat(order.start_date, 'date_3') }}~{{ datesFormat(order.end_date, 'date_3') }}
              </template>
              <template v-else>
                {{ datesFormat(order.start_date, 'date_3') }}~
              </template>
            </td>
            <td>{{ isFree ? 0 : order.subscribe_price | currency }}</td>
          </tr>
          </tbody>
        </table>

        <div class="flex-end" style="padding: 0 30px">
          <div style="font-size:11px;font-weight:bold;color:#363636;">이용 중인 서비스의 결제 금액</div>
          <div style="font-size:11px;margin-left:24px">{{ afterPayPrice | currency }}</div>
        </div>
      </template>

      <!-- 다음 결제일 청구 예정 내역 -->
      <template v-if="!isFree">
        <div class="terminate-modal-title" style="margin-bottom:24px;margin-top:60px">
          이용 중인 서비스 - 다음 결제일 청구 예정 내역
          <div class="terminate-modal-content" style="margin-top:8px">
            {{ beforePayDay }} 결제 예정 <br> 지금 중지 하면 아래 항목은 중지일 기준으로 정산 및 이용 중지되고 더 이상 청구되지 않습니다.
          </div>
        </div>
        <div v-if="before_pay.service_app_order.length>0 || before_pay.service_order">
          <table class="table amt-table" style="width:100%">
            <thead>
            <tr>
              <th class="col-1">구매일</th>
              <th class="col-1">결제예정일</th>
              <th class="col-1">구분</th>
              <th class="col-1">내용</th>
              <th class="col-3"></th>
              <th class="col-1">플랜</th>
              <th class="col-3">서비스 이용기간</th>
              <th class="col-1">정산금액</th>
            </tr>
            </thead>
            <tbody>
            <!-- 솔루션 -->
            <tr v-if="before_pay.service_order">
              <td>{{ datesFormat(before_pay.service_order.created_time, 'date_3') }}</td>
              <td>{{ payDay(before_pay.service_order) }}</td>
              <td>솔루션</td>
              <td>{{ before_pay.service_order.options[0].name }}</td>
              <td></td>
              <td>{{ before_pay.service_order.date_unit }}개월</td>
              <td>{{ datesFormat(before_pay.service_order.start_date, 'date_3') }}~{{ datesFormat(before_pay.service_order.end_date, 'date_3') }}</td>
              <td>{{ isFree ? 0 : usingSolutionPrice | currency }}</td>
            </tr>
            <!-- 호스팅 -->
            <tr v-if="before_pay.service_order">
              <td>{{ datesFormat(before_pay.service_order.created_time, 'date_3') }}</td>
              <td>{{ payDay(before_pay.service_order) }}</td>
              <td>호스팅</td>
              <td>{{ before_pay.service_order.hosting.name }}</td>
              <td></td>
              <td>{{ before_pay.service_order.date_unit }}개월</td>
              <td>{{ datesFormat(before_pay.service_order.start_date, 'date_3') }}~{{ datesFormat(before_pay.service_order.end_date, 'date_3') }}</td>
              <td>{{ isFree ? 0 : usinghostingPrice | currency }}</td>
            </tr>
            <tr v-for="(order, order_idx) in before_pay.service_app_order" :key="`order-${order_idx}`">
              <template>
                <td>{{ datesFormat(order.created_time, 'date_3') }}</td>
                <td>{{ payDay(order) }}</td>
                <td>{{ order.product.category1_name }}</td>
                <td>{{ order.product.category2_name }}</td>
                <td>{{ order.product.name }}</td>
                <td>{{ computedPlan(order) }}</td>
                <td>{{ datesFormat(order.start_date, 'date_3') }}~{{ datesFormat(currentDate, 'date_3') }}</td>
                <td>{{ isFree ? 0 : order.subscribe_price | currency }}</td>
              </template>
            </tr>
            </tbody>
          </table>
          <div class="flex-end" style="padding:0 30px">
            <div style="font-size:11px;font-weight:bold;color:#363636;">
              {{ datesFormat(service.service_order.next_date, 'date_3') }} 청구 예정 금액</div>
            <div style="font-size:11px;margin-left:24px">{{ billingPrice | currency }}</div>
          </div>
        </div>
        <div style="font-weight:400;color:#363636;font-size:11px" v-else>청구 예정 내역이 없습니다.</div>
      </template>

      <!-- 다음 결제일 갱신 예정 내역 -->
      <template v-if="!isFree">
        <div class="terminate-modal-title" style="margin-bottom:24px;margin-top:60px">
          이용 중인 서비스 - 다음 결제일 갱신 예정 내역
          <div class="terminate-modal-content" style="margin-top:8px">
            {{ datesFormat(service.service_order.next_date, 'date_3') }} 결제 예정 <br> 지금 중지 하면 다음 결제일에 아래 항목은 더 이상 결제, 갱신되지 않습니다.
          </div>
        </div>
        <div v-if="after_pay.service_app_order.length>0 || after_pay.service_order">
          <table class="table amt-table" style="width:100%">
            <thead>
            <tr>
              <th class="col-1">구매일</th>
              <th class="col-1">결제일</th>
              <th class="col-1">구분</th>
              <th class="col-1">내용</th>
              <th class="col-3"></th>
              <th class="col-1">플랜</th>
              <th class="col-3">서비스 이용기간</th>
              <th class="col-1">정산금액</th>
            </tr>
            </thead>
            <tbody>
            <!-- 솔루션 -->
            <tr v-if="after_pay.service_order">
              <td>{{ datesFormat(after_pay.service_order.created_time, 'date_3') }}</td>
              <td>{{ payDay(after_pay.service_order) }}</td>
              <td>솔루션</td>
              <td>{{ after_pay.service_order.options[0].name }}</td>
              <td></td>
              <td>{{ after_pay.service_order.date_unit }}개월</td>
              <td>{{ datesFormat(after_pay.service_order.start_date, 'date_3') }}~{{ datesFormat(after_pay.service_order.end_date, 'date_3') }}</td>
              <td>{{ isFree ? 0 : usingSolutionPrice | currency }}</td>
            </tr>
            <!-- 호스팅 -->
            <tr v-if="after_pay.service_order">
              <td>{{ datesFormat(after_pay.service_order.created_time, 'date_3') }}</td>
              <td>{{ payDay(after_pay.service_order) }}</td>
              <td>호스팅</td>
              <td>{{ after_pay.service_order.hosting.name }}</td>
              <td></td>
              <td>{{ after_pay.service_order.date_unit }}개월</td>
              <td>{{ datesFormat(after_pay.service_order.start_date, 'date_3') }}~{{ datesFormat(after_pay.service_order.end_date, 'date_3') }}</td>
              <td>{{ isFree ? 0 : usinghostingPrice | currency }}</td>
            </tr>
            <tr v-for="(order, order_idx) in after_pay.service_app_order" :key="`order-${order_idx}`">
              <template>
                <td>{{ datesFormat(order.created_time, 'date_3') }}</td>
                <td>{{ payDay(order) }}</td>
                <td>{{ order.product.category1_name }}</td>
                <td>{{ order.product.category2_name }}</td>
                <td>{{ order.product.name }}</td>
                <td>{{ computedPlan(order) }}</td>
                <td>{{ datesFormat(order.start_date, 'date_3') }}~{{ datesFormat(currentDate, 'date_3') }}</td>
                <td>{{ isFree ? 0 : order.subscribe_price | currency }}</td>
              </template>
            </tr>
            </tbody>
          </table>
          <div class="flex-end" style="padding:0 30px">
            <div style="font-size:11px;font-weight:bold;color:#363636;">
              {{ datesFormat(service.service_order.next_date, 'date_3') }} 갱신 예정 금액</div>
            <div style="font-size:11px;margin-left:24px">{{ afterPayPrice | currency }}</div>
          </div>
        </div>
        <div style="font-weight:400;color:#363636;font-size:11px" v-else>갱신 예정 내역이 없습니다.</div>
      </template>

      <!-- 해지 신청시 정산 청구 내역 -->
      <template v-if="!isFree">
        <div class="terminate-modal-title" style="margin-bottom:24px;margin-top:60px">
          {{ moment().format('YYYY.MM.DD') }}(오늘) 해지 신청 시 정산 청구 내역
        </div>
        <div v-if="before_pay.service_app_order.length>0 || before_pay.service_order">
          <table class="table amt-table" style="width:100%">
          <thead>
          <tr>
            <th class="col-1">구매일</th>
            <th class="col-1">결제일</th>
            <th class="col-1">구분</th>
            <th class="col-1">내용</th>
            <th class="col-3"></th>
            <th class="col-1">플랜
              <tool-tip1 style="margin-left:4px"
                        icon="u_question-circle"
                        :iconSize="16"
                        :text="'1개월 플랜: 일할계산 \n' +
              '3개월 플랜: 플랜 정가 기준 일할계산'"/>
            </th>
            <th class="col-3">서비스 이용기간</th>
            <th class="col-1">정산금액</th>
          </tr>
          </thead>
          <tbody>
          <!-- 솔루션 -->
          <tr v-if="before_pay.service_order">
            <td>{{ datesFormat(before_pay.service_order.created_time, 'date_3') }}</td>
            <td>{{ payDay(before_pay.service_order) }}</td>
            <td>솔루션</td>
            <td>{{ before_pay.service_order.options[0].name }}</td>
            <td></td>
            <td>{{ before_pay.service_order.date_unit }}개월</td>
            <td>{{ datesFormat(before_pay.service_order.start_date, 'date_3') }}~{{ datesFormat(before_pay.service_order.end_date, 'date_3') }}</td>
            <td>{{ isFree ? 0 : before_pay.service_order.options[0].price | currency }}</td>
          </tr>
          <!-- 호스팅 -->
          <tr v-if="before_pay.service_order">
            <td>{{ datesFormat(before_pay.service_order.created_time, 'date_3') }}</td>
            <td>{{ payDay(before_pay.service_order) }}</td>
            <td>호스팅</td>
            <td>{{ before_pay.service_order.hosting.name }}</td>
            <td></td>
            <td>{{ before_pay.service_order.date_unit }}개월</td>
            <td>{{ datesFormat(before_pay.service_order.start_date, 'date_3') }}~{{ datesFormat(before_pay.service_order.end_date, 'date_3') }}</td>
            <td>{{ isFree ? 0 : before_pay.service_order.hosting.price | currency }}</td>
          </tr>
          <tr v-for="(order, order_idx) in before_pay.service_app_order" :key="`order-${order_idx}`">
            <template>
              <td>{{ datesFormat(order.created_time, 'date_3') }}</td>
              <td>{{ payDay(order) }}</td>
              <td>{{ order.product.category1_name }}</td>
              <td>{{ order.product.category2_name }}</td>
              <td>{{ order.product.name }}</td>
              <td>{{ computedPlan(order) }}</td>
              <td>{{ datesFormat(order.start_date, 'date_3') }}~{{ datesFormat(currentDate, 'date_3') }}</td>
              <td>{{ accountPrice(order) | currency }}</td>
            </template>
          </tr>
          </tbody>
        </table>
          <div class="flex-end" style="padding:0 30px">
            <div style="font-size:11px;font-weight:bold;color:#363636;">해지 시 오늘 기준 청구 금액</div>
            <div style="font-size:11px;margin-left:24px">{{ accountTotalPrice | currency }}</div>
          </div>
        </div>
        <div style="font-weight:400;color:#363636;font-size:11px" v-else>정산 청구 내역이 없습니다.</div>
      </template>

      <!-- 솔루션 이용 해지 완료 후 서비스 호스팅 -->
      <template>
        <div class="terminate-modal-title" style="margin-bottom:24px;margin-top:60px">
          솔루션 이용 해지 완료 후 서비스 호스팅
        </div>
        <div class="terminate-modal-content" style="margin-bottom:24px">
          {{ datesFormat(service.service_order.next_date, 'date_3') }}에 결제 예정 <br>
          선택하신 서비스 상태는 이후에도 원하는 대로 변경할 수 있습니다.
        </div>

        <table class="table amt-table" style="width:100%">
          <thead>
          <tr>
            <th class="col-1">구매일</th>
            <th class="col-2">결제(예정)일</th>
            <th class="col-1">구분</th>
            <th class="col-3">내용</th>
            <th class="col-1">플랜</th>
            <th class="col-3">서비스 이용기간</th>
            <th class="col-1">금액</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{ moment().format('YYYY.MM.DD') }}</td>
            <td>{{ moment(service.service_order.next_date).format('YYYY.MM.DD') }}</td>
            <td>호스팅</td>
            <td>해지 후 호스팅: {{ selectedServiceStatusText }}</td>
            <td>1개월</td>
            <td>{{ datesFormat(service.service_order.start_date, 'date_3') }}~
              {{ moment(service.service_order.next_date).subtract(1, 'days').format('YYYY.MM.DD') }}</td>
            <td>{{ hostingPrice | currency }}</td>
          </tr>
          </tbody>
        </table>

        <div class="flex-end" style="padding: 0 30px">
          <div style="font-size:11px;font-weight:bold;color:#363636;">다음 결제일에 청구 될 금액</div>
          <div style="font-size:11px;margin-left:24px">{{ hostingPrice | currency }}</div>
        </div>
      </template>

      <div class="flex-end" style="padding: 0 30px;margin-top:24px;font-size:13px;">
        <div style="font-weight:bold;color:#363636;">총 결제 금액</div>
        <div style="margin-left:24px">{{ accountTotalPrice | currency }}</div>
      </div>

    </template>

    <div class="flex-center" style="margin-top:39px;margin-bottom:21px">
      <lp-check-bool :checkedVal.sync="check"
                     label="솔루션 이용 해지 후 서비스 유지를 위한 호스팅비가 결제 됨을 확인하였습니다."></lp-check-bool>
    </div>
    <div class="flex-center" style="margin-bottom:5px;font-size:11px;font-weight:500;color:#363636"
         v-if="terminateType(service.service_order)===2">
      결제 수단
      <span class="margin-left-8">{{ service.credit_card }}</span>
    </div>
    <div class="flex-center">
      <button class="button t-modal-btn" @click="stop">
        <span v-if="accountTotalPrice > 0">결제 및 이용 중지 완료</span>
        <span v-else>이용 중지</span>
      </button>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import ToolTip1 from "../../../module/common/ToolTip1";
  export default {
    name: "MarketTerminateModal",
    props: {
      service: {
        type: Object
      },
      selectedServiceStatus: {
        type: Number
      }
    },
    components: {ToolTip1, LpCheckBool},
    created() {
      this.getSelectorStocks();
      if(this.terminateType(this.service.service_order)===2) {
        this.before_pay.service_order = this.service.service_order;
      } else if(this.terminateType(this.service.service_order)===1) {
        this.after_pay.service_order = this.service.service_order;
      } else {
        this.after_pay.service_order = this.service.service_order;
      }
      let before_pay_service_app_order = [];
      let after_pay_service_app_order = [];
      this.service.service_app_order.forEach(order=>{
        // 결제전인 상품, 정기 결제 상품
        if(this.terminateType(order)===2 && order.is_subscription) {
          console.log('22222')
          before_pay_service_app_order.push(order);
        } else if(this.terminateType(order)===1 && order.is_subscription) {
          console.log('11111')
          after_pay_service_app_order.push(order)
        } else {
          after_pay_service_app_order.push(order)
        }
      })
      this.before_pay.service_app_order = before_pay_service_app_order;
      this.after_pay.service_app_order = after_pay_service_app_order;
    },
    data() {
      return {
        check: false,
        before_pay: {
          service_order: undefined,
          service_app_order: []
        },
        after_pay: {
          service_order: undefined,
          service_app_order: []
        },
        selectorStocks: [],
        product: undefined
      }
    },
    computed: {
      // 청구 결제일
      beforePayDay() {
        let next_date = ''
        this.before_pay.service_app_order.forEach(item=>{
          if(!next_date) {
            next_date = item.next_date
          } else {
            if(this.moment(next_date) > this.moment(item.next_date)) {
              next_date = item.next_date
            }
          }
        })
        if(this.before_pay.service_order) {
          if(this.moment(next_date) > this.moment(this.before_pay.service_order.next_date)) {
            next_date = this.before_pay.service_order.next_date
          }
        }
        if(next_date) {
          return this.datesFormat(next_date, 'date_3');
        } else {
          return ''
        }
      },
      isFree() {
        // let now = this.moment(this.moment().format('YYYY-MM-DD'))
        // let free_date = this.moment(order.free_date)
        // let diff = free_date.diff(now,'days')
        // console.log(order, now.format('YYYY-MM-DD'), free_date.format('YYYY-MM-DD'))
        // return diff >= 0
        return this.service.service_order.trial
      },
      usingSolutionPrice() {
        return this.getPlanPrice(this.service.service_order.options[0].id)
      },
      usinghostingPrice() {
        return this.service.service_order.hosting.price * this.service.service_order.date_unit;
      },
      hostingPrice() {
        let price = 0;
        if(this.selectedServiceStatus===10) price = 50000
        else if(this.selectedServiceStatus===99) price = 25000
        else if(this.selectedServiceStatus===100) price = 0
        return price;
      },
      selectedServiceStatusText() {
        let text = '';
        if(this.selectedServiceStatus===10) text = '서비스 유지'
        else if(this.selectedServiceStatus===99) text = '휴먼 전환'
        else if(this.selectedServiceStatus===100) text = '서비스 삭제'
        return text;
      },
      currentDate() {
        return this.moment().format('YYYY.MM.DD')
      },
      // 청구 예정 금액
      billingPrice() {
        let price = 0;
        if(this.before_pay.service_order) {
          price += this.before_pay.service_order.options[0].price;
          price += this.before_pay.service_order.hosting.price;
        }
        this.before_pay.service_app_order.forEach(order=>{
          price += order.subscribe_price;
        })
        return price;
      },
      // 정산금액 == 총 결제할 금액
      accountTotalPrice() {
        let price = 0;
        // 앱마켓
        this.service.service_app_order.forEach(order=>{
          if(this.terminateType(order)===2) {
            let start_date = this.moment(this.datesFormat(order.start_date, 'date_4'))
            let day = this.moment(this.currentDate).diff(start_date, 'days');

            let free_date = this.moment(this.datesFormat(order.free_date, 'date_4'))
            let next_date = this.moment(this.datesFormat(order.next_date, 'date_4'))

            let item1 = free_date.add(1, 'days').format('YYYY-MM-DD');
            let item2 = next_date.format('YYYY-MM-DD')
            // 첫 결제인 경우
            if(item1===item2) {
              price += day * this.calcOneDayPrice(order);
            }
            // 정기 결제인 경우
            else if(order.is_subscription) {
              price += day * this.calcOneDayPrice(order);
            }
          }
        })

        return Math.round(price);
      },
      // 이용 중인 서비스 결제 완료한 금액
      afterPayPrice() {
        let price = 0;
        if(!this.isFree) {
          this.after_pay.service_app_order.forEach(order => {
            price += order.subscribe_price;
          })
        }
        price += this.usinghostingPrice + this.usingSolutionPrice;
        return price;
      }
    },
    methods: {
      getSelectorStocks() {
        let product_id = this.service.service_order.options[0].product;
        this.$axios.get(`https://master-dev.launchpack.co.kr:1111/public/launchpack/v1/theme/${product_id}`).then(res=>{
          this.product = res.data;
        })
        let url = this.masterBackendUrl + `public/product/${product_id}/selector_stocks`
        this.$axios.post(url).then(res => {
          this.selectorStocks = res.data.stocks;
        })
      },
      getPlanPrice(option_id) {
        let date_unit = this.service.service_order.date_unit
        let price = 0;
        let stock = find(this.selectorStocks, 'id', option_id);
        if(this.product) {
          this.product.selectors.forEach(item=>{
            let data = find(item.options, 'id', stock.options[0])
            if(data) {
              if(date_unit===1) {
                price = data.price
              } else {
                let item = find(data.subscriptions, 'date_unit', date_unit)
                price = item.price
              }
            }
          })
        }
        return price * date_unit
      },
      // 정산 금액
      accountPrice(order) {
        let price = 0;
        if(!this.isFree) {
          price = this.calcOneDayPrice(order)
        }
        return price;
      },
      calcOneDayPrice(order) {
        return order.subscribe_price / order.date_unit / 30
      },
      // 팩,플러그인 이용중지
      terminateType(order) {
        // 0: 무료기간, 1: 결제후 2: 결제전
        let type = 0
        let now = this.moment(this.moment().format('YYYY-MM-DD'))
        let next_date = this.moment(order.next_date)
        let end_date = this.moment(order.end_date)
        if(this.isFree) type = 0
        // 현재일 < 결제일 < 이용기간종료일
        else if(now < next_date && end_date > next_date) type = 2
        else type = 1
        return type
      },
      payDay(order) {
        let text = '';
        // 무료 체험 기간일 경우
        if(this.isFree) {
          text = '-'
        } else {
          text = this.moment(order.next_date).format('YYYY.MM.DD')
        }
        return text;
      },
      computedPlan(order) {
        let text = '';
        // 정기 결제일 경우
        if(order.is_subscription) {
          text = order.date_unit + '개월'
        } else {
          text = '건 결제'
        }
        return text;
      },
      stop() {
        this.$emit('stop', this.accountTotalPrice)
      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .amt-table th,
  .amt-table td
    text-align center
    padding 6px 0

  .amt-table th
    font-weight 500
    font-size 13px

  .amt-table td
    font-weight 400
    font-size 11px

  .amt-table tr
    border-bottom 1px solid #dddddd

  .amt-table tbody tr:last-child
    border-bottom 1px solid #000000

  .terminate-modal-title
    color #363636
    font-weight 500
    font-size 13px

  .terminate-modal-content
    color #363636
    font-width 400
    font-size 11px

  .t-modal-btn
    width 230px
    height 32px
    background $primary
    color white
    border-radius 3px
    font-size 11px
    font-weight 400
</style>
